var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./CategoryList.module.scss";
import CategoryItem from "../CategoryItem/CategoryItem";
import { useDispatch, useSelector } from "react-redux";
import { currentSessionId, getCategories, sendMessage, setIsResponseLoading } from "../../stores/reducers/chatReducer";
import { CONTACT_BUTTON_POSITION_TOP, CONTACT_BUTTON_POSITION_BOTTOM, getSettings, getTranslation, default_settings } from "../../constants/setting";
import { forEach, isEmpty } from "lodash";
import { Button, FormSelect } from "react-bootstrap";
import { MESSAGE_TYPE_CONTACT_FORM } from "../../constants";
import { getTextColor } from "../../helper";
import { isLanguageRTL } from "../../../../constants";
import chatBotApi from "../../api/chatbot";
var ContactButton = function (props) {
    var primary_color = getSettings().primary_color;
    var text = props.text;
    return _jsx(Button, __assign({ className: styles.contactBtnTrigger, type: "button", onClick: props.showContactForm, style: {
            backgroundColor: primary_color,
            borderColor: primary_color,
            fontWeight: 700,
            color: getTextColor(primary_color)
        } }, { children: _jsx("div", __assign({ className: styles.label }, { children: text || default_settings.contact_button_text })) }));
};
var CategoryList = function (props) {
    var categories = useSelector(getCategories);
    var dispatch = useDispatch();
    var sessionId = useSelector(currentSessionId);
    var _b = getSettings(), enable_contact_button_in_category = _b.enable_contact_button_in_category, contact_button_text = _b.contact_button_text, contact_button_position = _b.contact_button_position, topics = _b.topics, enable_contact_us_form = _b.enable_contact_us_form, language = _b.language, category_display_type = _b.category_display_type;
    var showContactForm = function () {
        dispatch(sendMessage({
            response: {
                type: MESSAGE_TYPE_CONTACT_FORM,
                language: language,
                data: {
                    text: getTranslation('chatbot.send_contact_form') + ':',
                    show: true,
                    submitted: false,
                    topics: topics
                }
            }
        }));
    };
    var onCategorySelect = function (text) {
        dispatch(setIsResponseLoading(true));
        chatBotApi.fetchQuestions(sessionId, text).then(function (response) {
            forEach(response.data, function (value, key) {
                dispatch(sendMessage({
                    response: value
                }));
            });
        }).catch(function (err) {
            console.error(err);
            console.log(err);
        }).finally(function () {
            dispatch(setIsResponseLoading(false));
        });
    };
    return _jsx(_Fragment, { children: (!isEmpty(categories) || (enable_contact_us_form && enable_contact_button_in_category)) && _jsxs("div", __assign({ className: "".concat(styles.categoryWrapper, " ").concat(isLanguageRTL(language) && styles.rtl) }, { children: [_jsxs("h5", __assign({ className: styles.heading }, { children: [getTranslation('chatbot.categories'), ":"] })), _jsxs("div", __assign({ className: styles.categoryList }, { children: [enable_contact_us_form && enable_contact_button_in_category && contact_button_position === CONTACT_BUTTON_POSITION_TOP ? _jsx(ContactButton, { showContactForm: showContactForm, text: contact_button_text }) : null, category_display_type === 'buttons' ? _jsx(_Fragment, { children: categories === null || categories === void 0 ? void 0 : categories.map(function (categoryName, index) {
                                return _jsx(CategoryItem, { text: categoryName, onChange: function (text) { return onCategorySelect(text); } }, 'category_' + index);
                            }) }) : null, category_display_type === 'dropdown' ? _jsx(_Fragment, { children: _jsxs(FormSelect, __assign({ onChange: function (e) { return onCategorySelect(e.target.value); } }, { children: [_jsx("option", __assign({ value: "" }, { children: getTranslation('chatbot.select_category') }), 'category'), categories === null || categories === void 0 ? void 0 : categories.map(function (categoryName, index) {
                                        return _jsx("option", __assign({ value: categoryName }, { children: categoryName }), 'category' + index);
                                    })] })) }) : null, enable_contact_us_form && enable_contact_button_in_category && contact_button_position === CONTACT_BUTTON_POSITION_BOTTOM ? _jsx(ContactButton, { showContactForm: showContactForm, text: contact_button_text }) : null] }))] })) });
};
export default CategoryList;
